// 菜单路由配置 - 按布局分类

// 1. 默认布局页面（带 Header）
export const defaultLayoutPages = [
  {
    path: "/index",
    name: "首页",
    component: () => import("../views/index/IndexView.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: false,
      role: "user",
      title: "首页",
    },
  },
  {
    path: "/creativeNaming",
    name: "CreativeNaming",
    component: () => import("../views/creativeNaming/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "创意取名",
    },
  },
  // {
  //   path: "/inventionDrafting",
  //   name: "InventionDrafting",
  //   component: () => import("../views/inventionDrafting/chemicalInvention/index.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     role: 'user',
  //     title: '专利方案挖掘'
  //   }
  // path: "/newCreationDeduction",
  // name: "NewCreationDeduction",
  // redirect: '/newCreationDeduction/inventionDrafting',
  // component: { render: (h) => h('router-view') },
  // meta: {
  //   requiresAuth: true,
  //   keepAlive: true,
  //   role: 'user',
  //   title: '专利方案挖掘'
  // },
  // children: [
  //   {
  //     path: "inventionDrafting",
  //     name: "InventionDrafting",
  //     component: () => import("../views/inventionDrafting/chemicalInvention/index.vue"),
  //     meta: {
  //       requiresAuth: true,
  //       role: 'user',
  //       title: '一键撰写全文'
  //     }
  //   },
  // {
  //   path: "technicalDisclosureDoc",
  //   name: "TechnicalDisclosureDoc",
  //   component: () => import("../views/newCreationDeduction/technicalDisclosureDoc.vue"),
  //   props: true,
  //   meta: {
  //     requiresAuth: true,
  //     role: 'user',
  //     title: '链式推导交底书'
  //   }
  // },
  // {
  //   path: "disclosureAssistant",
  //   name: "DisclosureAssistant",
  //   component: () => import("../views/newCreationDeduction/disclosureAssistant.vue"),
  //   props: true,
  //   meta: {
  //     requiresAuth: true,
  //     role: 'user',
  //     title: '一键撰写交底书'
  //   }
  // },
  // {
  //   path: "newApplicationWrite",
  //   name: "NewApplicationWrite",
  //   component: () => import("../views/newCreationDeduction/newApplicationWrite.vue"),
  //   props: true,
  //   meta: {
  //     requiresAuth: true,
  //     role: 'user',
  //     title: '五书撰写'
  //   }
  // },
  // {
  //   path: "historyListPage",
  //   name: "HistoryListPage",
  //   component: () => import("../views/newCreationDeduction/historyList.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     role: 'user',
  //     title: '历史列表'
  //   }
  // }
  // ]
  // },

  {
    path: "/historyListPage",
    name: "HistoryListPage",
    component: () => import("../views/newCreationDeduction/historyList.vue"),
    meta: {
      requiresAuth: true,
      isShow: false, // 设置为 false 时，该菜单项不会在 Header 中显示
      role: "user",
      title: "历史列表",
    },
  },
  {
    path: "/novelty",
    name: "NoveltySearchReport",
    component: () =>
      import("../views/searchreport/components/NoveltySearchReport.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "专利申请前检索报告",
      badge: "偏正面",
    },
  },
  {
    path: "/patentDrafting",
    name: "PatentDrafting",
    redirect: "/patentDrafting/instructions",
    component: { render: (h) => h("router-view") },
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "专利撰写",
      badge: "交底较齐全",
    },
    children: [
      {
        path: "instructions",
        name: "Instructions",
        component: () => import("../views/instructions/index.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "说明书撰写",
        },
      },
      {
        path: "writingOfClaims",
        name: "WritingOfClaims",
        component: () => import("../views/writingOfClaims/index.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "权利要求书撰写",
        },
      },
      {
        path: "writingOfClaimsElectrical",
        name: "WritingOfClaimsElectrical",
        component: () =>
          import("../views/patentDrafting/writingOfClaimsElectrical/index.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "权利要求书撰写（电学）",
        },
      },
      {
        path: "writingOfClaimsGeneral",
        name: "WritingOfClaimsGeneral",
        component: () =>
          import("../views/patentDrafting/writingOfClaimsGeneral/index.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "权利要求书撰写（通用）",
        },
      },
    ],
  },
  // {
  //   path: "/review",
  //   name: "ReviewMaterials",
  //   component: () => import("../views/searchreport/components/ReviewMaterials.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     keepAlive: true,
  //     hiddenInMenu: true,
  //     role: 'user',
  //     title: '优审材料撰写'
  //   }
  // },
  {
    path: "/innovationResponse",
    name: "InnovationResponse",
    component: () => import("../views/innovationResponse/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "审查意见答复 (OA)",
    },
  },
  {
    path: "/purchasePoints",
    name: "PurchasePoints",
    component: () => import("../views/purchasePoints/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "积分",
      hiddenInMenu: true,
    },
  },
  {
    path: "/purchaseMember",
    name: "PurchaseMember",
    component: () => import("../views/purchaseMember/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "会员",
      hiddenInMenu: true,
    },
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/order/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "订单信息",
      hiddenInMenu: true,
    },
  },
  {
    path: "/childUser",
    name: "ChildUser",
    component: () => import("../views/childUser/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "子账号管理",
      hiddenInMenu: true,
    },
  },
  {
    path: "/recommendationOfficer",
    name: "RecommendationOfficer",
    component: () => import("../views/recommendationOfficer/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "推荐官管理",
      hiddenInMenu: true,
    },
  },
  {
    path: "/sharepage",
    name: "Sharepage",
    component: () => import("../views/sharepage/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "分享",
      hiddenInMenu: true,
    },
  },
  {
    path: "/searchreport",
    name: "SearchReport",
    redirect: "/searchreport/noveltyBookReport",
    component: { render: (h) => h("router-view") },
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "专利检索",
      hiddenInMenu: true,
    },
    children: [
      {
        path: "noveltyBookReport",
        name: "NoveltyBookReport",
        component: () =>
          import("../views/searchreport/components/NoveltySearchReport.vue"),
        meta: {
          requiresAuth: true,
          noMainPadding: false,
          role: "user",
          title: "专利申请前检索报告",
        },
      },
      {
        path: "ai-search",
        name: "AISearchAgent",
        component: () =>
          import("../views/searchreport/components/AISearchAgent.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "AI 智能体",
          noMainPadding: true,
        },
      },
      {
        path: "keyword",
        name: "KeywordSearch",
        component: () =>
          import("../views/searchreport/components/KeywordSearch.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "关键词检索",
          noMainPadding: false,
        },
      },
      {
        path: "semantic",
        name: "SemanticRetrieval",
        component: () =>
          import("../views/searchreport/components/SemanticRetrieval.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "语义检索",
          noMainPadding: false,
        },
      },
      {
        path: "stability",
        name: "StabilityReport",
        component: () =>
          import("../views/searchreport/components/StabilityReport.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "稳定性报告",
          noMainPadding: false,
        },
      },
      {
        path: "contrast",
        name: "Contrast",
        component: () => import("../views/contrast/index.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "技术对比",
          noMainPadding: true,
        },
      },
      {
        path: "understand",
        name: "Understand",
        component: () => import("../views/understand/index.vue"),
        meta: {
          requiresAuth: true,
          role: "user",
          title: "技术快速理解",
          noMainPadding: true,
        },
      },
    ],
  },
  {
    path: "/historyList",
    name: "HistoryList",
    component: () => import("../views/newCreationDeduction/historyList.vue"),
    meta: {
      requiresAuth: true,
      role: "user",
      title: "历史列表",
      hiddenInMenu: true,
    },
  },
  // {
  //   path: "/inventionDrafting",
  //   name: "InventionDraftingStandalone",
  //   component: () => import("../views/inventionDrafting/chemicalInvention/index.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     isShow: false,
  //     role: 'user',
  //     title: '专利方案挖掘',
  //     hiddenInMenu: true
  //   }
  // }
];

// 2. 空白布局页面（无Header）
export const blankLayoutPages = [
  // 登录相关
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/index.vue"),
    meta: {
      requiresAuth: false,
      role: "user",
      title: "登录",
      hiddenInMenu: true,
    },
  },
  // 其他独立页面
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/privacy/index.vue"),
    meta: {
      requiresAuth: false,
      role: "user",
      title: "隐私条款",
      hiddenInMenu: true,
    },
  },
  {
    path: "/paymentServiceAgreement",
    name: "PaymentServiceAgreement",
    component: () => import("../views/paymentServiceAgreement/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "支付服务协议",
      hiddenInMenu: true,
    },
  },
  {
    path: "/serviceAgreement",
    name: "ServiceAgreement",
    component: () => import("../views/serviceAgreement/index.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "user",
      title: "推广中介服务协议",
      hiddenInMenu: true,
    },
  },
  // 管理员路由
  {
    path: "/memberManagement/memberLogin",
    name: "MemberLogin",
    component: () => import("../views/memberManagement/memberLogin.vue"),
    meta: {
      requiresAuth: false,
      role: "admin",
      title: "管理员登录",
      hiddenInMenu: true,
    },
  },
  {
    path: "/memberManagement/pointsSearch",
    name: "PointsSearch",
    component: () => import("../views/memberManagement/pointsSearch.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      role: "admin",
      title: "管理员积分查询",
      hiddenInMenu: true,
    },
  },
];

// 3. 404 页面（空白布局）
export const notFoundRoute = {
  path: "*",
  name: "NotFound",
  component: () => import("../views/NotFound/index.vue"),
  meta: {
    requiresAuth: false,
    role: "user",
    title: "404",
  },
};

// 4.官网路由
export const websiteRoutes = [
  {
    path: "index",
    name: "WebsiteIndex",
    component: () => import("../views/website/index.vue"),
    meta: {
      requiresAuth: false,
      role: "user",
      title: "官网首页",
    },
  },
  {
    path: "userManual",
    name: "UserManual",
    component: () => import("../views/website/userManual/index.vue"),
    meta: {
      requiresAuth: false,
      role: "user",
      title: "使用手册",
    },
  },
  {
    path: "priceAll",
    name: "PriceAll",
    component: () => import("../views/website/priceAll.vue"),
    meta: {
      requiresAuth: false,
      role: "user",
      title: "产品介绍",
    },
  },
  {
    path: "partnership",
    name: "Partnership",
    component: () => import("../views/partnership/index.vue"),
    meta: {
      requiresAuth: false,
      role: "user",
      title: "合作伙伴",
    },
  },
];
